// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { Color } from '@models/color';
import { ListTaskStatus_abstract } from './../abstract/SagaStateLib/ListTaskStatus_abstract';
export class ListTaskStatus extends ListTaskStatus_abstract {
  private _color: Color;
  get color(): Color {
    if (!this._color) {
      this._color = new Color(this.FColor);
    }
    return this._color;
  }

  private _colorRgb: string;
  get colorRgb(): string {
    if (!this._colorRgb) {
      this._colorRgb = this.color.toRgbString();
    }

    return this._colorRgb;
  }
}
